import React from 'react';

import {MainTitle} from './MainTitle.jsx';
import {LibrarySelector} from './LibrarySelector.jsx';
import {SearchBox} from './SearchBox.jsx';
import {ViewSelector} from './ViewSelector.jsx';

var Header = React.createClass({
    onInputlist: function(value){
      this.props.onInputlist(value); // set the list selector property (true or false).
    },

    onInputgrid: function(value){
      this.props.onInputgrid(value); // set the grid selector property (true or false).
    },

    onLibrarySelect: function(value){
      this.props.onLibrarySelect(value); // set the property(value) of library selector.
    },

    libSelectShow: function(){
      this.props.libSelectShow();
    },

    searchPackage: function(value) {
      this.props.searchPackage(value);
    },

    render: function(){
      return(
        <div className="header">
        <div className="content-header">
          <div className="content__col content__col--first">
            <MainTitle />
            <LibrarySelector  onLibrarySelect = {this.onLibrarySelect}
                              libSelect = {this.props.libSelect}
                              libSelectShow = {this.libSelectShow} 
                              library = {this.props.library} />
          </div>
         <SearchBox searchPackage = {this.searchPackage}/>
         <ViewSelector  onInputlist = {this.onInputlist} 
                        onInputgrid = {this.onInputgrid}
                        listview = {this.props.listview} 
                        gridview = {this.props.gridview}  />
        </div>
      </div>
      );
  }
});

export {Header};


/** WEBPACK FOOTER **
 ** ./html/components/Header.jsx
 **/